<template>
  <div :class="'container-' + uniqueKey">
    <md-field
      :md-counter="false"
      :md-inline="!label || !label.length"
      :md-toggle-password="passwordIcon"
      :md-clearable="clearable"
      :class="{ 'md-invalid': invalid }"
    >
      <label>{{ label }}</label>

      <md-textarea
        :class="{
          'cursor-stop': maxlength && value && value.length >= maxlength,
        }"
        :placeholder="placeholder"
        :value="value"
        @input="handleEmit"
        :type="type"
        :maxlength="maxlength"
        :required="required"
        :disabled="disabled"
        spellcheck="false"
      />

      <span class="md-error vp-pl-2 vp-pt-4">{{ errMsg }}</span>
    </md-field>
  </div>
</template>

<script>
import "vue-material/dist/theme/default.css";
import { randomStringMixin } from "@/utils/mixins/generateRandomStringMixin";
export default {
  data() {
    return {
      uniqueKey: this.randomString(10),
    };
  },
  mixins: [randomStringMixin],
  props: {
    type: {
      type: String,
      default: "text",
    },
    required: {
      type: Boolean,
      default: false,
    },
    passwordIcon: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    errMsg: {
      type: String,
      default: "There is an error",
    },
    value: {
      type: String,
      default: "",
    },
    /* ------ Placeholder props ------ */
    placeholder: {
      type: String,
      default: "",
    },
    maxlength: {
      type: String,
      default: "",
    },
    // placeholderFontSize: {
    //   type: String,
    //   default: "16px",
    // },
    // placeholderFoneWeight: {
    //   type: String,
    //   default: "400",
    // },
    // placeholderFontColor: {
    //   type: String,
    //   default: "#606060de",
    // },

    /* ------ Container props ------ */
    width: {
      type: String,
      default: "422px",
    },
    height: {
      type: String,
      default: "121",
    },
    backgroundColor: {
      type: String,
      default: "#f2f2f2",
    },

    /* ------ Input props ------ */
    fontSize: {
      type: String,
      default: "16px",
    },
    fontWeight: {
      type: String,
      default: "700",
    },
    fontColor: {
      type: String,
      default: "#000000de",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    /* ------ Label props ------ */
    label: {
      type: String,
      default: "",
    },
    labelFontSize: {
      type: String,
      default: "13px",
    },
    labelFontWeight: {
      type: String,
      default: "700",
    },
    labelColor: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleEmit(value) {
      this.$emit("input", value);
    },
    setBackgroundOnDisabled() {
      const textarea = document.querySelector(
        `.container-${this.uniqueKey} .md-textarea`
      );

      const label = document.querySelector(
        `.container-${this.uniqueKey} label`
      );

      if (this.disabled) {
        textarea?.style.setProperty("opacity", "0.4", "important");
        label?.style.setProperty("opacity", "0.4", "important");
      } else {
        textarea?.style.setProperty("opacity", "1", "important");
        label?.style.setProperty("opacity", "1", "important");
      }
    },
  },
  mounted() {
    //Selectors
    const container = document.querySelector(
      `.container-${this.uniqueKey} .md-theme-default`
    );
    const label = document.querySelector(`.container-${this.uniqueKey} label`);
    const textarea = document.querySelector(
      `.container-${this.uniqueKey} .md-textarea`
    );

    //Container styles
    container.style.width = this.width + "px";
    container.style.height = +this.height + "px";
    container.style.backgroundColor = this.backgroundColor;

    //Label styles
    label.style.fontSize = this.labelFontSize;
    label.style.color = this.labelColor;
    label.style.fontWeight = this.labelFontWeight;

    //textarea styles
    // textarea.style.height = +this.height -10 +'px';
    textarea.style.fontSize = this.fontSize;
    textarea.style.fontWeight = this.fontWeight;
    textarea.style.fontWeight = this.fontColor;
    textarea.style.backgroundColor = this.backgroundColor;
    textarea.style.paddingBottom = "5px";
    this.setBackgroundOnDisabled();
  },
  watch: {
    disabled() {
      this.setBackgroundOnDisabled();
    },
  },
};
</script>

<style lang="scss" scoped>
/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
div[class*="container-"] {
  .md-field.md-required label:after {
    top: 4px;
  }
  .invalid-input {
    color: #f46a6a;
  }
  .md-field.md-theme-default {
    border-radius: 4px;
    label {
      top: 16px;
      font-size: 16px !important;
      font-weight: 400 !important;
      color: #8c8c8c !important;
    }

    .md-textarea {
      padding-inline-start: 10px;
    }
    .md-field.md-has-textarea label {
      inset-inline-start: 10x;
    }
  }

  .md-field.md-theme-default.md-has-value,
  .md-field.md-theme-default.md-focused {
    label {
      top: 0 !important;
      color: #103f5e !important;
      font-size: 12px !important;
      font-weight: 700 !important;
      padding-top: 4px;
    }
    .md-textarea{
      -webkit-text-fill-color: #4A4A4A !important;
    }
  }

  .md-inline {
    .md-input {
      padding-bottom: 0.625rem;
    }
  }
}
</style>

<style lang="scss">
div[class*="container-"] {
  .md-textarea {
    padding-inline-start: 15px !important;
    border-radius: 4px;
    resize: none !important;
    margin-top: 5px;
    font-size: 16px;
    font-weight: 600 !important;
  }
  .md-button.md-icon-button {
    margin-inline-end: 5px;
  }
  .md-field.md-theme-default:after,
  .md-field.md-theme-default:before {
    display: none;
  }
  .cursor-stop {
    cursor: not-allowed;
  }

  .md-textarea::-webkit-scrollbar {
    width: 9px;
    height: 30px !important;
  }
  .md-textarea::-webkit-scrollbar-track {
    background: #c7c7c7;
    padding-top: 30px !important;
    border-radius: 8.5px;
    -webkit-box-shadow: #ffff;
  }
  .md-textarea::-webkit-scrollbar-thumb {
    background: #666666;
    border-radius: 8.5px;
  }
}
</style>
